import { Button, Text } from "@aidron/aidron-ds";
import { CustomHeading } from "../../StyledComponents/styleComponents.index";

export const SessionWarningModal = ({ actions, uiState}) => {

  const { onClose, onContinueSession, onLogout } = actions || {};
  const { t } = uiState || {};
    
  const overlayStyle = {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(2px)",
  };

  const modalStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    maxWidth: "480px",
    textAlign: "center",
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <CustomHeading size="sm" margin="0 0 16px">
          {t("attention")}
        </CustomHeading>

        <Text
          label={
            t("sessionMessage")
          }
        />

        <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
          <Button
            label={t("continue")}
            type="filled"
            onClick={onContinueSession}
          />
          <Button
            label={t("logout")}
            type="outlined"
            onClick={onLogout}
          />
        </div>
      </div>
    </div>
  );
};
